import styled from 'styled-components';

import {
  Grid as SemanticGrid,
  Menu as SemanticMenu,
  Message as SemanticMessage,
} from 'semantic-ui-react';

import { Loader as LoaderLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-anchor: none
`;

const ContainerParticipants = styled.div`
  display: flex;
`;

const Loader = styled(LoaderLayoutComponent)`
`;

const ErrorMessage = styled(TextLayoutComponent)`
`;

const Grid = styled(SemanticGrid)`
  &&& {
    margin: 0px;
    padding: 0px 10px;
    text-align: center;
    width: 100%;
  }
`;

const Row = styled(SemanticGrid.Row)`
`;

const Column = styled(SemanticGrid.Column)`
`;

const ColumnText = styled(TextLayoutComponent.Header)`
`;

const Divider = styled.hr`
  border-bottom: none;
  border-top: 1px solid ${(props) => props.theme.color.divider};
  margin: 20px 0px;
  width: 100%;
`;

const ClickableData = styled(TextLayoutComponent)`
  cursor: pointer;
`;

const Menu = styled(SemanticMenu)``;

const ContainerMenu = styled.div`
  display: flex;
  align-self: flex-start;
  margin-bottom: 28px;
`;

const MenuItem = styled(Menu.Item)``;

const Message = styled(SemanticMessage)`
  display: flex;
  flex-direction: column;
  width: 60%;
`;

const ContentIdLabels = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CintIdLabel = styled.p`
  color: black;
  font-size: 16px;
  margin: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const MrIdLabel = styled.p`
  color: black;
  font-size: 16px;
  // align vertically
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 16px;
`;

const ContainerSpace = styled.div`
  display: flex;
  justify-content: space-between;
`;

export {
  ClickableData,
  Column,
  ColumnText,
  Container,
  Divider,
  ErrorMessage,
  Grid,
  Loader,
  Row,
  Menu,
  ContainerMenu,
  MenuItem,
  Message,
  ContentIdLabels,
  CintIdLabel,
  MrIdLabel,
  ContainerParticipants,
  ContainerSpace,
};
